import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#878787",
      "fill-rule": "evenodd",
      d: "M13.838 6.162a2.6 2.6 0 1 0-3.677 3.677 2.6 2.6 0 0 0 3.677-3.677m-4.95-1.273a4.4 4.4 0 1 1 6.223 6.222A4.4 4.4 0 0 1 8.888 4.89M6.028 15.09c1.655-.963 3.817-1.483 5.972-1.483 2.154 0 4.316.52 5.97 1.483 1.646.959 2.93 2.453 2.93 4.409v1a1.9 1.9 0 0 1-1.9 1.9H5a1.9 1.9 0 0 1-1.9-1.9v-1c0-1.956 1.283-3.45 2.929-4.409m.906 1.556C5.592 17.428 4.9 18.429 4.9 19.5v1a.1.1 0 0 0 .1.1h14a.1.1 0 0 0 .1-.1v-1c0-1.07-.693-2.072-2.035-2.853-1.334-.777-3.172-1.24-5.065-1.24s-3.732.463-5.066 1.24",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }